import React, { useState, useEffect, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import { getOrderHistory } from '../../context/CommonContex';
import OrderHistoryGroupedView from './OrderHistoryGroupedView';
import './OrderHistoryModal.css';

const OrderHistoryModal = ({ show, onClose, ordernum, onViewed }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const fetchHistory = useCallback(async () => {
        if (!ordernum) return;
        setLoading(true);
        setError(false);
        try {
            const data = await getOrderHistory(ordernum);
            setHistory(Array.isArray(data) ? data : []);
            // Opening history marks it reviewed for the current user (per-user localStorage).
            if (typeof onViewed === 'function') {
                onViewed(ordernum);
            }
        } catch (err) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }, [ordernum, onViewed]);

    useEffect(() => {
        if (show) {
            fetchHistory();
        } else {
            setHistory([]);
        }
    }, [show, fetchHistory]);

    return (
        <Modal show={show} onHide={onClose} centered dialogClassName="order-history-modal-dialog" enforceFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '18px' }}>{`Order History — ${ordernum}`}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {loading && (
                    <div className="text-center py-4">
                        <div className="spinner-border spinner-border-sm text-secondary" role="status" />
                        <div className="mt-2 text-muted">Loading history…</div>
                    </div>
                )}
                {!loading && error && (
                    <div className="text-center text-danger py-4">Failed to load history. Please try again.</div>
                )}
                {!loading && !error && history.length === 0 && (
                    <div className="text-center text-muted py-4">No history recorded for this order yet.</div>
                )}
                {!loading && !error && history.length > 0 && (
                    <OrderHistoryGroupedView entries={history} />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default OrderHistoryModal;
